import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
import ActionDialog from '@/components/campaigns/action/ActionDialog.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfirmFinishDialog',
    props: {
        modelValue: { type: Boolean },
        campaignName: {},
        isRecurrent: { type: Boolean },
        loading: { type: Boolean }
    },
    emits: ["update:modelValue", "confirm", "cancel"],
    setup(__props, { emit }) {
        const props = __props;
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(ActionDialog, {
                "model-value": _ctx.modelValue,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = val => emit('update:modelValue', val)),
                loading: _ctx.loading,
                tone: 'danger',
                "confirm-label": _ctx.$t('breadcrumb.email.campaigns.dialogs.finish.confirm'),
                "cancel-label": _ctx.$t('cancel'),
                onConfirm: _cache[1] || (_cache[1] = ($event) => (emit('confirm'))),
                onCancel: _cache[2] || (_cache[2] = ($event) => (emit('cancel')))
            }, {
                title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaigns.dialogs.finish.title')), 1)
                ]),
                description: _withCtx(() => [
                    _createElementVNode("span", {
                        innerHTML: _ctx.$t('breadcrumb.email.campaigns.dialogs.finish.description-base', { name: props.campaignName })
                    }, null, 8, _hoisted_1),
                    (props.isRecurrent)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(_ctx.$t('breadcrumb.email.campaigns.dialogs.finish.recurrent-extra')), 1)
                        ], 64))
                        : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('breadcrumb.email.campaigns.dialogs.finish.after-text')) + " ", 1),
                    _createElementVNode("strong", null, _toDisplayString(_ctx.$t('breadcrumb.email.campaigns.dialogs.finish.warning')), 1)
                ]),
                _: 1
            }, 8, ["model-value", "loading", "confirm-label", "cancel-label"]));
        };
    }
});
